import { BadgeProps } from "components/ui/badge";
import { TransferRow } from "./transfer-types";

export interface TransferStatusBadge {
    label: string;
    type: BadgeProps["type"];
}

const badges: Record<TransferRow["status"], TransferStatusBadge> = {
    Pending: { label: "Pending", type: "highlight" },
    Accepted: { label: "Accepted", type: "success" },
    Rejected: { label: "Declined", type: "error" },
    Cancelled: { label: "Cancelled", type: "info" },
};

export const transferStatusBadge = (status: TransferRow["status"]): TransferStatusBadge =>
    badges[status];

export interface TransferStatusOption {
    value: TransferRow["status"];
    label: string;
}

export const transferStatusOptions: TransferStatusOption[] = (
    Object.keys(badges) as TransferRow["status"][]
).map(value => ({ value, label: badges[value].label }));
